import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import HeroImagePanel from "../../components/common/HeroImagePanel";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { useFormSubmitGuard } from "../../hooks/useFormSubmitGuard";
import { HERO_IMAGE_URL } from "../../constants/siteContent";

export default function AdminLoginPage() {
  const { isAuthenticated, login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);

  useFormSubmitGuard(pending);

  const from = location.state?.from || "/admin";

  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      await login({ email, password });
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign in failed.");
    } finally {
      setPending(false);
    }
  }

  return (
    <main className="admin-login-page">
      <div className="admin-login-overlay" />
      <section className="admin-login-content">
        <div className="admin-login-panel">
          <h1>Admin sign in</h1>
          <p className="admin-login-hint">Wedding site administration.</p>
          {error ? (
            <p className="admin-login-error" role="alert">
              {error}
            </p>
          ) : null}
          <form
            className="admin-login-form"
            onSubmit={handleSubmit}
            aria-busy={pending}
            data-submitting={pending ? "true" : undefined}
          >
            <fieldset className="admin-form-fieldset" disabled={pending}>
              <legend className="visually-hidden">Sign in credentials</legend>
              <label htmlFor="admin-email">Email</label>
              <input
                id="admin-email"
                name="email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label htmlFor="admin-password">Password</label>
              <input
                id="admin-password"
                name="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button type="submit">{pending ? "Signing in…" : "Sign in"}</button>
            </fieldset>
            {pending ? (
              <p className="form-status-text" role="status" aria-live="polite">
                Signing you in — please keep this page open.
              </p>
            ) : null}
          </form>
        </div>
      </section>
      <HeroImagePanel className="admin-login-image" imageUrl={HERO_IMAGE_URL} />
    </main>
  );
}
